import { useNavigate } from "react-router-dom";
import {
  formatDateForStatsList,
  PlatformSource,
  RecentAnswer,
} from "winslow-core";
import "./CollectionStatsQuestionList.css";
import { useDispatch, useSelector } from "react-redux";
import {
  selectUIStates,
  setSidebarAnswer,
  setUIStates,
} from "../../redux/features/appData";
import { getCategoryColor } from "./colorData";
import { FeedbackRating } from "../agent-chat/FeedbackRating";
import { EscalationIndicator } from "../common/EscalationIndicator";

type CollectionStatsQuestionListProps = {
  questions: RecentAnswer[];
  categoryColors: {
    category: string;
    color: string;
  }[];
  showFeedbackRatings?: boolean;
  onRatingDelete?: () => void;
};

export const CollectionStatsQuestionList = ({
  questions,
  showFeedbackRatings,
  onRatingDelete,
}: CollectionStatsQuestionListProps) => {
  const navigate = useNavigate();
  const uiStates = useSelector(selectUIStates);
  const dispatch = useDispatch();

  return (
    <>
      {questions.map((response: RecentAnswer) => (
        <div
          key={"collection-stats-questions-" + response.id}
          className="collection-stats-questions"
          onClick={() => {
            console.log("collectionstats click");
            dispatch(setSidebarAnswer({ ...response }));
            dispatch(
              setUIStates({
                ...uiStates,
                answerSidebarOpen: true,
              })
            );
          }}>
          {/* Platform Icon */}
          <div className="collection-stats-platform-source">
            {response.platformSource === PlatformSource.SLACK && (
              <img src="/icons/slack.svg" alt="Slack Icon" />
            )}
            {response.platformSource === PlatformSource.OUTLOOK && (
              <img src="/icons/outlook.svg" alt="Outlook Icon" />
            )}
            {response.platformSource === PlatformSource.TEAMS && (
              <img src="/icons/teams.png" alt="Teams Icon" />
            )}
            {(response.platformSource === PlatformSource.IOS_MOBILE ||
              response.platformSource === PlatformSource.ANDROID_MOBILE ||
              response.platformSource === PlatformSource.WEB) && (
              <img src="/icons/winslow-ai-logo.svg" alt="Winslow AI Logo" />
            )}
            {response.platformSource === PlatformSource.GMAIL && (
              <img src="/icons/gmail.svg" alt="Gmail Icon" />
            )}
          </div>

          {/* Question */}
          <div className="collection-stats-questions-question">
            {response.question}
          </div>

          {/* User */}
          <div className="collection-stats-questions-user">
            <div className="collection-stats-questions-avatar">
              <img src={response?.avatarURL || ""} alt={response.name || ""} />
            </div>
            <div className="collection-stats-user-info">
              <div className="collection-stats-questions-name">
                {response.name}
              </div>
            </div>
          </div>

          <div className="collection-stats-questions-admin">
            <div className="collection-stats-questions-avatar">
              {response.adminAvatar && response.adminName && (
                <img
                  src={response?.adminAvatar || ""}
                  alt={response.adminName || ""}
                />
              )}
            </div>
            <div className="collection-stats-admin-info">
              <div className="collection-stats-questions-name">
                {response?.adminName || ""}
              </div>
            </div>
          </div>

          {/* Category or Rating */}
          {showFeedbackRatings ? (
            <div
              className="collection-stats-questions-rating"
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
              }}>
              {response.message?.id && (
                <FeedbackRating
                  messageId={response.message.id}
                  feedbackRating={response.message.feedbackRating as any}
                  onRatingDelete={onRatingDelete}
                />
              )}
            </div>
          ) : (
            <div className="collection-stats-questions-category">
              {response.category && (
                <div
                  className="collection-stats-questions-category-label"
                  style={{
                    backgroundColor: getCategoryColor(response.category),
                  }}>
                  {response.category}
                </div>
              )}
            </div>
          )}

          {/* Escalation Indicator */}
          <div className="collection-stats-questions-escalation">
            {response.requiredEscalation && <EscalationIndicator size={16} />}
          </div>

          {/* Date */}
          <div className="collection-stats-questions-date">
            {formatDateForStatsList(new Date(response.createdAt))}
          </div>
        </div>
      ))}
    </>
  );
};
